<template>
  <b-row>
    <b-col>
      <b-card>
        <i class="fa fa-hard-hat fa-lg"></i><span class="h6 ml-2">{{ $t('views.excmcase.list.title') }}</span>
        <span v-if="ableToAddCase" class="float-right">
          <button type='button' @click="showModal()" class="btn btn-info btn-circle btn-sm mt-0 mb-2 ml-1 mr-2" v-b-tooltip.hover :title="$t('views.excmcase.create.title')">
            <i class="fa fa-plus"></i>
          </button>
        </span>
        <hr class="mt-2 mb-1">
        <Loader v-if="isLoading" size="lg"></Loader>
        <div v-else>
          <div v-if="items.length > 0">
            <table class="table table-sm table-responsive-lg table-hover table-striped">
              <thead>
              <tr>
                <th class="w-2"></th>
                <th>
                  {{$t('views.excmcase.list.id')}}
                </th>
                <th>
                  {{$t('views.excmcase.form.contractorUserData')}}
                </th>
                <th class="text-center">{{ $t('views.excmtask.list.progress') }}</th>
                <th class="text-center">
                  {{$t('views.excmcase.show.currentTask')}}
                </th>
                <th>
                  {{$t('views.excmcasetype.list.table.title')}}
                </th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="item in items" class="p-2" :key="item['@id']">

                <td>
                    <span v-b-tooltip.hover :title="item.status.title" class="h6 mt-0 mb-0">
                        <i :class="item.status.class + ' fa-lg mr-2'" :style="'color: ' + item.status.color"></i>
                    </span>
                </td>

                <td>
                  <router-link
                    :to="{name: 'EXCMCaseShow', params: { id: item['@id'] }}">
                    <span v-if="item.number">{{item.number}}</span>
                    <span v-else>{{getIdLink(item['@id'])}}</span>
                  </router-link>
                </td>

                <td>
                  <div v-if="item.contractorUserData">
                    <span v-if="item.contractorUserData.firmname1">{{item.contractorUserData.firmname1}}</span>
                    <span v-else-if="item.contractorUserData.fullName">{{item.contractorUserData.fullName}}</span>
                    <div v-if="item.contractorUserData.phone">{{$t('views.excmcase.show.phone')}}: <phoneNumberLink :phoneNumber="item.contractorUserData.phone"/></div>
                    <div v-if="item.contractorUserData.mobilePhone">{{$t('views.excmcase.show.mobilePhone')}}: <phoneNumberLink :phoneNumber="item.contractorUserData.mobilePhone"/></div>
                    <div>{{ item.contractorUserData.fullAddress }}</div>
                    <div v-if="item.contractorUserData.userEmail"><a :href="'mailto:' + item.contractorUserData.userEmail">{{ item.contractorUserData.userEmail }}</a></div>
                    <div v-if="item.contractorUserData.contactEmail"><a :href="'mailto:' + item.contractorUserData.contactEmail">{{ item.contractorUserData.contactEmail }}</a></div>
                  </div>
                </td>

                <td class="text-center">
                  <div v-if="item.deadlineDate">
                    <b-badge :variant="getProgress(item) > 100 ? 'danger' : null">
                      {{ getProgress(item) > 100 ? $t('views.excmtask.list.deadlineExceeded') : getProgress(item) + ' %' }}
                    </b-badge>
                    <small class="d-block">
                      {{ $moment(item.createdAt).format('YYYY-MM-DD HH:mm') }}
                    </small>
                    <small class="d-block">
                      {{' - ' + $moment(item.deadlineDate).format('YYYY-MM-DD HH:mm')}}
                    </small>
                    <Progress
                      v-if="getProgress(item) < 100"
                      :type="'primary'"
                      :value="getProgress(item)">
                    </Progress>
                  </div>
                  <b-badge v-else>
                    {{ $t('views.excmcase.list.noDeadlineDate') }}
                  </b-badge>
                </td>

                <td v-if="item.lastTask" class="text-center">
                    {{item.lastTask.idTaskType.title}}
                <td v-else> </td>

                <td>
                  {{item.caseType.title}}
                </td>
              </tr>
              </tbody>
            </table>
          </div>
          <div v-else>
            {{$t('views.excmcase.list.noCases')}}
          </div>
        </div>
        <div v-if="view">
          <pagination
            :view="view"
            @getPage="getList($event)"
          ></pagination>
        </div>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import Loader from '@/components/Dashboard/Layout/Loader'
import Pagination from '@/components/Dashboard/Layout/Pagination'
import { checkPermission } from '@/utils/checkRoles'
import { mapMutations, mapGetters, mapActions } from 'vuex'
import getId from '@/utils/getIdFromLink'
import Progress from '@/components/UIComponents/Progress'
import PhoneNumberLink from '@/components/Dashboard/Views/firm/components/PhoneNumberLink'

export default {
  name: 'ClientCases',
  components: {
    PhoneNumberLink,
    Loader,
    Pagination,
    Progress
  },
  computed: {
    ...mapGetters({
      error: 'excmcase/list/error',
      items: 'excmcase/list/items',
      isLoading: 'excmcase/list/isLoading',
      view: 'excmcase/list/view'
    }),
    ableToAddCase () {
      return checkPermission('cases', 'EXCMCaseCreate')
    }
  },

  created () {
    this.getList()
  },

  methods: {
    getProgress (item) {
      if (!item.deadlineDate) {
        return 100
      } else {
        let created = this.$moment(item.createdAt)
        let deadline = this.$moment(item.deadlineDate)
        return this.calculateProgress(created, deadline)
      }
    },
    calculateProgress (created, deadline) {
      let denominator, nominator
      denominator = deadline.diff(created)
      nominator = this.$moment().diff(created)
      return Math.round((nominator / denominator) * 100)
    },
    getIdLink (link) {
      return getId(link)
    },
    showModal () {
      this.toggleModal()
    },
    ...mapMutations({
      toggleModal: 'excmcase/createModal/toggleCreateCaseModal'
    }),
    ...mapActions({
      getList: 'excmcase/list/fetchCases'
    })
  }
}
</script>

<style scoped>

</style>
